import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';

// Odkazy z doby HashRouteru (chopstickssazava.cz/#/admin – např. záložka na tabletu
// v provozovně) přepíšeme na skutečnou cestu ještě před mountem Reactu. Bez toho
// skončí uživatel na landing page a do adminu se vůbec nedostane.
if (window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);